import { createContext, useContext, useMemo, useState } from "react";

const ShoppingCartStagesValueContext = createContext();
const ShoppingCartStagesActionsContext = createContext();

export function ShoppingCartStagesContextProvider({ children }) {
    const [shoppingCartStages, setShoppingCartStages] = useState(null);

    const shoppingCartStagesActions = useMemo(
        () => {
            return {
                onSet(newValues) {
                    setShoppingCartStages(newValues);
                },
                setValue: setShoppingCartStages
            }
        },
        []
    )

    return (
        <>
            <ShoppingCartStagesActionsContext.Provider value={{ shoppingCartStages: shoppingCartStagesActions }}>
                <ShoppingCartStagesValueContext.Provider value={{ shoppingCartStages }}>
                    {children}
                </ShoppingCartStagesValueContext.Provider>
            </ShoppingCartStagesActionsContext.Provider>
        </>
    );
}

export function useShoppingCartStagesValueContextHook(props) {
    const value = useContext(ShoppingCartStagesValueContext);

    if (value === undefined) {
        throw new Error('useShoppingCartStagesValueContextHook should be used within ShoppingCartStagesContextProvider');
    }

    return {
        shoppingCartStages: value.shoppingCartStages,
    };
}

export function useShoppingCartStagesActionsContextHook(props) {
    const value = useContext(ShoppingCartStagesActionsContext);

    if (value === undefined) {
        throw new Error('useShoppingCartStagesActionsContextHook should be used within ShoppingCartStagesContextProvider');
    }

    return {
        shoppingCartStages: {
            onSet: value.shoppingCartStages.onSet,
            setValue: value.shoppingCartStages.setValue
        },
    };
}